import React, { Component } from 'react';
import Header from '../../components/main.header.component';
class BigHeads extends Component {

  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    return (
      <div className="BigHeads">
        <Header
          props={this.props}
        />
        <div className="bigheads-headline">
            <i>Big Heads</i> was a site-specific installation for: <br />
          <a href="http://www.hawaii.edu/art/news+updates/?p=772" target="_blank" rel="noopener noreferrer" >
            <i>INTO VIEW: an exhibition of 'narcissists'. </i>
          </a>
        </div>
          <div className="bigheads-text">
            <p>As a glimpse into my critical examination of the artist's role in modern society, <i>Big Heads</i> examines the narcissistic personality traits which the art world promotes.</p>
            In contemporary art, an emphasis is placed upon "high" or "intellectual" art. In response, artists are reaching for their thesaurus in order to convince an audience of their intelligence. <br />
            This assurance of artistic genius stems from the interconnectedness to historical artistry and contemporary art critics which place artists on a higher level of thought.<br />
            The hegemonic powers of the art curators and museologists create a paradoxical dichotomy from which artistic genius has become less about the artist and more about the curator who “discovers" them.<br />
            <p>The ortho-litho film, which holds the image, scarcely veils the world behind it, allowing the viewer to either address the piece, or look through it. <br />
            <br />
            This transparency also introduces a tongue-in-cheek criticism of the amount of credit the curator's took for
            <i> INTO VIEW </i>, almost as if the artwork itself was meant to be secondary, or even slightly invisbile to the audience.</p>
          </div>
        <div className="bigheads-responsive">
          <div className="bigheads-image">
            <img src="/images/bigheads/BigHeadsOutside.jpg" alt=""/>
          </div>
          <div className="bigheads-image">
            <img src="/images/bigheads/BigHeads3.jpg" alt=""/>
          </div>
          <div className="bigheads-image">
            <img src="/images/bigheads/BigHeads2.jpg" alt=""/>
          </div>
          <div className="bigheads-image">
            <img src="/images/bigheads/BigHeads-Person.jpg" alt=""/>
          </div>
          <div className="bigheads-image">
            <img src="/images/bigheads/BigHeadsArticle.jpg" alt=""/>
          </div>
        </div>
          <div className="bigheads-text-small">
            <p>Medium/media - Ortho Litho Film, Tape, String<br />
              Dimensions - (center) 60 x 48 x 1", (left) 40 x 32 x 5", (right) 40 x 32 x 5"</p>
              <br />
              <br />
            The ortho-litho film was invented as a tool for early screenprinters/newspaper workers to create a larger, high contrast, solid black and transparent image. Allowing early users to make images in a format which could be easily be translated into print.
            Through experimentation and research, I have discovered a way to create a continuous tone that can be obtained from the film through dilution of the chemical developer, (meaning I can get a wider range of middle-grey and decrease the high contrast nature of the film).<br />
            I find it is important to understand the misuse of the material in order to understand a bit more of my artistic practice. Rather than follow already figured out results and apply them to my work, I would rather figure out a way through experimentation and trial and error on my own.

          </div>
      </div>
    );
  }
}

export default BigHeads;

